import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
    dialogContainer: {
        borderRadius: 'var(--border-radius)',
        minWidth: 600,
        [theme.breakpoints.down('sm')]: {
            minWidth: '98%',
            minHeight: '98%'
        }
    },
    dialogContent: {
        padding: '0 !important'
    },
    dialogTitle: {
        padding: 0,
        position: 'relative',
        zIndex: 1,
        '& .MuiIconButton-root': {
            position: 'absolute',
            top: 4,
            right: 4
        }
    },
    iframe: {
        width: '100%',
        minHeight: 900,
        border: 0,
        '& body': {
            backgroundColor: 'hotpink'
        }
    }
}))
